import { CookieService } from 'ngx-cookie-service';

export class AuthUtils{
    static deleteAuthCookies(cookieService: CookieService){
        cookieService.delete('ports-token', '/', 'vmware.com');
        cookieService.delete('ports-email', '/', 'vmware.com');
        cookieService.delete('ports-user', '/', 'vmware.com');
    }
}